import { Injectable } from '@angular/core';
import { firstValueFrom } from 'rxjs';
import { environment } from '@base/environments/environment';
import { HttpService } from '../core/http.service';
import { PopupInterfaceNew } from '../models/popups.model';

@Injectable({
  providedIn: 'root',
})
export class PopupService extends HttpService {
  basePanelUrl = environment.apiEndpoint;
  remaxEndpoint = environment.remaxEndpoint;
  utils: any;

  //------------------------------------------------------------Modulo Popups

  async getPopupsList(): Promise<PopupInterfaceNew> {
    const RESPONSE = await firstValueFrom(
      this.http.get<PopupInterfaceNew>(this.basePanelUrl + '/panel/popups/', {
        observe: 'response',
        responseType: 'json',
      })
    );

    if (!RESPONSE.body) {
      throw new Error('No popup data received');
    }

    return RESPONSE.body;
  }

  async getPopup(id: number): Promise<any> {
    const data = await firstValueFrom(
      this.http.get(`${this.basePanelUrl}/panel/popups/${id}`)
    );
    return JSON.parse(JSON.stringify(data));
  }

  async putPopup(body: any): Promise<any> {
    const RESPONSE = await firstValueFrom(
      this.http.put<any>(this.basePanelUrl + '/panel/popups/', body, {
        observe: 'response',
        responseType: 'json',
      })
    );
    return RESPONSE.body;
  }

  async postPopup(formData: any): Promise<any> {
    const RESPONSE = await firstValueFrom(
      this.http.post<any>(this.basePanelUrl + '/panel/popups/', formData, {
        observe: 'response',
        responseType: 'json',
      })
    );
    return RESPONSE.body;
  }

  async editPopup(formData: any): Promise<any> {
    const RESPONSE = await firstValueFrom(
      this.http.post<any>(this.basePanelUrl + '/panel/popups/edit', formData, {
        observe: 'response',
        responseType: 'json',
      })
    );
    return RESPONSE.body;
  }

  async deletePopup(id: number): Promise<any> {
    const RESPONSE = await firstValueFrom(
      this.http.delete<any>(this.basePanelUrl + '/panel/popups/' + id, {
        observe: 'response',
        responseType: 'json',
      })
    );
    return RESPONSE.body;
  }
}
